import Axios from 'axios'

import type {
  TCompanyDto,
  TUpdateCompanyRequest,
  TUpdateCompanyResponse
} from '@homepal/api-contract'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/companies`

export async function getAll() {
  return getWithRedirect<TCompanyDto[]>(URL)
}

export async function update(body: TUpdateCompanyRequest) {
  return Axios.patch<TUpdateCompanyResponse>(
    URL,
    body,
    parseAuthenticationHeader()
  )
}
